interface PlaceholderProps {
  colSize?: number;
}

const CustomPlaceholder: React.FC<PlaceholderProps> = ({ colSize = 12 }) => {
  return (
    <p className="card-text text-center placeholder-glow">
      <span className={`placeholder col-${colSize}`} />
    </p>
  );
};

export default CustomPlaceholder;
